<template>
  <div class="variable-bomb" style="width: 720px;left: 560px; top: 100px;">
    <div class="bomb-box-title br4">
      <b class="f14 c51">变量说明</b>
    </div>
    <div class="bomb-box-content">
      <table class="variable-info-table w100">
        <thead>
          <tr>
            <th style="width:115px">名称</th>
            <th>变量</th>
            <th>说明</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(record, index) in varList"
            :key="index"
            data-type="general"
          >
            <td>{{ record.name }}</td>
            <td>{{ record.var }}</td>
            <td>
              {{ record.description }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getVarListColl, getVarListDesign , getVarList } from "@/api/template/template"
export default {
  data() {
    return {
      varList: [],
    }
  },
  methods: {
    async getVarList() {
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if (pId) {
        let result = await getVarListColl()
        this.varList = result.rows
      }  else if(designId) {
        let result = await getVarListDesign()
        this.varList = result.rows
      } else{
        let result = await getVarList()
        this.varList = result.rows
      }
    },
  },
  mounted() {
    this.getVarList()
  },
}
</script>

<style lang="scss" scoped>
.render-info-bomb,
.variable-bomb {
  position: fixed;
  z-index: 10001;
  background: #fff;
  border: 1px solid rgb(225, 227, 229);
  border-radius: 5px;
  font-size: 12px; 
}

.render-info-bomb {
  width: 430px;
  padding: 10px 20px;
}

.render-info-bomb .render-tit {
  padding: 10px 0;
}

.render-info-bomb .render-text {
  color: #989898;
}

.render-info-bomb .img-info {
  margin-top: 5px;
  margin-left: 68px;
}

.render-info-bomb .img-info > span {
  margin-left: 170px;
}

.variable-bomb .bomb-box-title {
  text-align: center;
  background: #fff;
}

.variable-bomb .bomb-box-content {
  padding-top: 5px !important;
}

.variable-preview .bomb-box-content {
  max-height: calc(100% - 200px);
}

.bomb-box.variable-preview .bomb-box-title {
  background-color: #e6ebf2;
}

.variable-info-table,
.variable-info-table th,
.variable-info-table td,
.variable-preview-table,
.variable-preview-table th,
.variable-preview-table td {
  border-collapse: collapse;
  border: 1px solid rgb(225, 227, 229) !important;
}

.variable-info-table th,
.variable-info-table td,
.variable-preview-table th,
.variable-preview-table td {
  padding: 10px 15px;
}

.variable-info-table thead tr,
.variable-preview-table thead tr {
  background: #f5f7fa;
}

.variable-info-table tbody tr td:nth-child(1),
.variable-info-table tbody tr td:nth-child(2) {
  text-align: center;
}

.variable-preview-table {
  table-layout: fixed;
  word-break: break-all;
}

.variable-preview-table tbody tr td:nth-child(1) {
  text-align: center;
  min-width: 130px;
  width: 130px !important;
}

.variable-preview-table tbody tr td:nth-child(2) {
  width: 360px;
}

.variable-preview-table tbody tr td:nth-child(2) > div {
  max-height: 85px;
  overflow: auto;
}
.bomb-box-title {
  background-color: rgb(245, 247, 250);
  line-height: 40px;
  padding: 0 15px;
}

.br4 {
  border-radius: 4px;
}
.w100 {
  width: 100%;
}
</style>
